interface StatCardProps {
  label: string;
  value: string | number;
  icon: string;
  iconBg: string;
  iconColor: string;
  trend?: number;
  trendLabel?: string;
  onClick?: () => void;
}

export default function StatCard({ label, value, icon, iconBg, iconColor, trend, trendLabel, onClick }: StatCardProps) {
  const isPositive = trend !== undefined && trend > 0;
  const isNegative = trend !== undefined && trend < 0;

  return (
    <div
      className={`app-card p-5 transition-all duration-200 ${onClick ? "cursor-pointer hover:-translate-y-0.5 hover:shadow-xl" : ""}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${iconBg} ring-1 ring-black/5`}>
          <i className={`${icon} text-xl ${iconColor}`} />
        </div>
        {trend !== undefined && (
          <div className={`flex items-center gap-1 text-xs font-semibold ${isPositive ? "text-emerald-600" : isNegative ? "text-red-500" : "text-gray-400"}`}>
            <div className="w-3 h-3 flex items-center justify-center">
              <i className={`${isPositive ? "ri-arrow-up-line" : isNegative ? "ri-arrow-down-line" : "ri-subtract-line"} text-xs`} />
            </div>
            {Math.abs(trend)}%
          </div>
        )}
      </div>
      <div className="text-2xl font-bold text-slate-900 mb-1">{value}</div>
      <div className="text-sm text-slate-500">{label}</div>
      {trendLabel && (
        <div className="text-xs text-slate-400 mt-1">{trendLabel}</div>
      )}
    </div>
  );
}
